import { useContext } from 'react'
import styled from 'styled-components'
import { ExamSubject } from 'generated/graphql'
import DetailInfoTable from '@app.feature/exam/gsat2024-2/components/detailInfoTable/DetailInfoTable'
import { PredictionOfPassedContainerContext } from '@app.feature/exam/gsat2024-2/context/PredictionOfPassedContainerContext'
import { generateTableData } from '@app.feature/exam/gsat2024-2/modules/detailInfoArticleTableData.module'

const DetailInfoArticleMobile = () => {
  const { examGradingResultData } = useContext(
    PredictionOfPassedContainerContext,
  )

  const tableDataList = {
    math: {
      ...(examGradingResultData && {
        ...generateTableData(examGradingResultData, ExamSubject.MATH),
      }),
    },
    reasoning: {
      ...(examGradingResultData && {
        ...generateTableData(examGradingResultData, ExamSubject.REASONING),
      }),
    },
  }
  return (
    <StyledWrapper>
      <div className="table-scroll-box">
        <DetailInfoTable tableDataList={tableDataList} />
      </div>
    </StyledWrapper>
  )
}

export default DetailInfoArticleMobile

const StyledWrapper = styled.article`
  width: 100%;
  padding: 24px 20px;
  border-radius: 20px;
  background-color: #fff;

  > .table-scroll-box {
    width: 100%;
    overflow-x: scroll;
  }
`
